import { gql } from "@apollo/client";

export const GetEmployee = gql`
  query GetEmployee($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      id
      ... on EmpMaster {
        id
        name
        empType
        address
        place
        state
        pin
        email
        mobile
        status
        gender
        rights
        lastAccessed
        firebaseID
        isLoginCreated
        authID
        customerID
        companyID
        subsidiaryID
        siteID
        customer {
          name
        }
      }
    }
  }
`;

export const GetUserRights = gql`
  query GetUserRights(
    $token: String!
    $customerID: ID!
    $after: Cursor
    $first: Int
    $orderBy: UserRightsMasterOrder # $name: String
  ) {
    GetUserRights(
      token: $token
      customerID: $customerID
      after: $after
      first: $first
      orderBy: $orderBy # where: { or: [{ defaultTheme: $name }] }
    ) {
      edges {
        node {
          id
          empID
          defaultTheme
          isSysadmin
          tableLevel
          empDetails {
            id
            name
            empType
            address
            place
            state
            pin
            email
            mobile
            status
            gender
            rights
            lastAccessed
            customer {
              name
            }
          }
          rightsDetails {
            id
            subsidiaryID
            companyID
            siteID
            junctionID
            user_rights_master_id
            subsidiaryDetails {
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetAtsCompany = gql`
  query node($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      id
      ... on AtsCompany {
        id
        name
        address
        place
        state
        pin
        country
        contactPerson
        contactPersonDesign
        contactPersonEmail
        contactPersonMobile
        email
        mobile
        url
        logoFilename
        isActive
        panNo
        gstNo
        tanNo
        vatNo
        oth1No
        oth2No
        latitude
        longitude
        timeZone
        customerID
      }
    }
  }
`;

export const GetUserRightsByEmpId = gql`
  query GetUserRightsByEmpId($token: String!, $customerID: ID!, $empID: ID!) {
    GetUserRightsByEmpId(
      token: $token
      customerID: $customerID
      empID: $empID
    ) {
      id
      empID
      defaultTheme
      isSysadmin
      tableLevel
      empDetails {
        id
        name
        empType
        address
        place
        state
        pin
        email
        mobile
        status
        gender
        rights
        lastAccessed
        companyID
        subsidiaryID
        siteID
        customer {
          name
        }
      }
      rightsDetails {
        id
        subsidiaryID
        companyID
        siteID
        junctionID
        user_rights_master_id
        company {
          id
          name
        }
        subsidiaryDetails {
          id
          name
          slNo
          address
          contactPerson
          email
          mobile
        }
        siteDetails {
          name
        }
        junctionDetails {
          name
        }
      }
    }
  }
`;
